import { render, staticRenderFns } from "./updatePassword.vue?vue&type=template&id=07aa1c26"
import script from "./updatePassword.vue?vue&type=script&lang=js"
export * from "./updatePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports